import { fetchWebhooks } from '@/api/webhook'
import { useRequiredOrgId } from '@/hooks/useRequiredOrgId'
import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/lib/query-keys'

export const useOrgWebhooks = () => {
  const organizationId = useRequiredOrgId()

  return useQuery({
    queryKey: queryKeys.webhooks.all(organizationId),
    queryFn: () => fetchWebhooks(organizationId),
    enabled: !!organizationId,
  })
}
